import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { BuildingControlProjectsType } from "../../Controllers/Types/BuildingControl/BuildingControlProjectsType";
import { baseURL } from "../ApiConstant";

// For get all building control projects
export const getAllBuildingControlProjects = async () => {
    try {
        const response = await apiClient.get(`/api/building-control-project-data`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        // Handle error (display error message, log, etc.)
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};


// For Add project to the building control
export const addProjectForBuildingControl = async (projectList: BuildingControlProjectsType[]): Promise<CommonApiResponse> => {
    try {
        // prepare ids for number list
        const list = projectList.map((e) => e.project_id);

        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/building-control-project-add`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: JSON.stringify({ list }),
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};